import { apiClient } from "./NetworkService";
// @ts-ignore
import ApiNames from "../constants/ApiNames";
import type { ApiResponse } from "../types/home";
import type {
  GenerateTokenRequest,
  GenerateTokenResponse,
  AuthenticateTokenRequest,
  AuthenticateTokenResponse,
  SendOtpResponse,
  SubscribeFastFlowRequest,
  SubscribeRequest,
  SubscribeResponse,
  CheckUserResponse,
  CheckOperatorResponse,
  UnsubscribeResponse,
  AwarenessFlowResponse,
} from "../types/auth";

// Helper to inject token if provided
const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const generateToken = async (
  data: GenerateTokenRequest,
): Promise<GenerateTokenResponse> => {
  const res = await apiClient.post<GenerateTokenResponse>(
    ApiNames.generateToken,
    data,
  );
  return res.data;
};

export const authenticateToken = async (
  data: AuthenticateTokenRequest,
  token?: string,
): Promise<ApiResponse<AuthenticateTokenResponse>> => {
  const res = await apiClient.post(
    ApiNames.authenticateToken,
    data,
    getHeaders(token),
  );
  return res.data;
};

export const getFLow = async (token?: string): Promise<ApiResponse<any>> => {
  const res = await apiClient.get(ApiNames.getFLow, getHeaders(token));
  return res.data;
};

export const sendOtp = async (
  msisdn: string,
  token?: string,
): Promise<ApiResponse<SendOtpResponse>> => {
  const res = await apiClient.get(
    `${ApiNames.sendOtp}?msisdn=${msisdn}`,
    getHeaders(token),
  );
  return res.data;
};

export const loginSendOtp = async (
  msisdn: string,
  token?: string,
): Promise<ApiResponse<SendOtpResponse>> => {
  const res = await apiClient.get(
    `${ApiNames.loginSendOtp}?msisdn=${msisdn}`,
    getHeaders(token),
  );
  return res.data;
};

export const subscribeFastFlow = async (
  data: SubscribeFastFlowRequest,
  token?: string,
): Promise<ApiResponse<SubscribeResponse>> => {
  const res = await apiClient.post(
    ApiNames.subscribeFastFlow,
    data,
    getHeaders(token),
  );
  return res.data;
};

export const subscribe = async (
  data: SubscribeRequest,
  token?: string,
): Promise<ApiResponse<SubscribeResponse>> => {
  const res = await apiClient.post(ApiNames.subscribe, data, getHeaders(token));
  return res.data;
};

export const chekUser = async (
  msisdn: string,
  token?: string,
): Promise<ApiResponse<CheckUserResponse>> => {
  const res = await apiClient.get(
    `${ApiNames.chekUser}?msisdn=${msisdn}`,
    getHeaders(token),
  );
  return res.data;
};

export const checkOperator = async (
  msisdn: string,
  token?: string,
): Promise<ApiResponse<CheckOperatorResponse>> => {
  const res = await apiClient.get(
    `${ApiNames.checkOperator}?msisdn=${msisdn}`,
    getHeaders(token),
  );
  return res.data;
};

export const unsubscrib = async (
  msisdn: string,
  token?: string,
): Promise<ApiResponse<UnsubscribeResponse>> => {
  const formData = new FormData();
  formData.append("msisdn", msisdn);
  const headers = getHeaders(token);
  const res = await apiClient.post(ApiNames.unsubscrib, formData, {
    ...headers,
    headers: { ...headers.headers },
  });
  return res.data;
};

export const awarenessFlow = async (
  utmSource: string,
  token?: string,
): Promise<ApiResponse<AwarenessFlowResponse>> => {
  const res = await apiClient.get(
    `${ApiNames.awarenessFlow}?utm_source=${utmSource}`,
    getHeaders(token),
  );
  return res.data;
};
